import { render, staticRenderFns } from "./AdminExportClientsItem.vue?vue&type=template&id=d84bc4ec&"
import script from "./AdminExportClientsItem.vue?vue&type=script&lang=js&"
export * from "./AdminExportClientsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports